module.exports = __webpack_public_path__ + "img/4.c2fd6999.png";